import React from 'react';
import classes from './Button.module.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({ className, children, ...rest }) => {
    const combinedClassName = `${classes.button} ${className ? className : ''}`;

    return (
        <button className={combinedClassName} {...rest}>
            {children}
        </button>
    );
};

export default Button;